import React from 'react';
import App from './app';
import { RootPage } from 'components/core/root-page';

new RootPage({
  app: <App />,
});
